import { DefaultTheme } from 'styled-components';
import { tokens } from '../../components/ThemeProvider/ThemeProvider';

type Token = keyof DefaultTheme[typeof tokens];

export const token = (name: Token) => {
  return ({ theme }: { theme: DefaultTheme }) => {
    return theme[tokens][name];
  };
};
